import React from 'react';

function Header() {
    return (
        <nav className='navbar navbar-expand-lg navbar-light bg-light d-flex justify-content-center'>
            <h1 className='navbar-brand '>MoneySaved</h1>
        </nav>
    )

}

export default Header;